import {TAppRootState} from 'core/redux/types';
import {IArticlesState} from '../types';
import {articlesModuleName} from '../slice';

const select = (state: TAppRootState): IArticlesState => state[articlesModuleName];

export const selectArticleTypes = (state: TAppRootState): IArticlesState['articleTypes'] => select(state).articleTypes;
export const selectArticleSeo = (state: TAppRootState): IArticlesState['seo'] => select(state).seo;

export const selectArticlesByCategory = (state: TAppRootState): IArticlesState['articlesByCategory'] =>
    select(state).articlesByCategory;

export const selectIsArticlesByTag = (state: TAppRootState): IArticlesState['isArticlesByTag'] =>
    select(state).isArticlesByTag;

export const selectIsCategoryType = (state: TAppRootState): IArticlesState['isCategoryType'] =>
    select(state).isCategoryType;

export const selectSimilarArticles = (state: TAppRootState): IArticlesState['similarArticles'] =>
    select(state).similarArticles;

export const selectArticleXSeo = (state: TAppRootState): IArticlesState['articleXSeo'] => select(state).articleXSeo;

export const selectArticleXProducts = (state: TAppRootState): IArticlesState['articleProducts'] =>
    select(state).articleProducts;

export const selectArticleXData = (state: TAppRootState): IArticlesState['articleXData'] => select(state).articleXData;
